import { FC } from "react";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { Moon, Sun } from "lucide-react";
import { useThemeToggle } from "@/hooks/useThemeToggle";

type ThemeToggleButtonProps = {
  id?: string;
  className?: string;
  switchToLightLabel: string;
  switchToDarkLabel: string;
};

const ThemeToggleButton: FC<ThemeToggleButtonProps> = ({
  id,
  className,
  switchToLightLabel,
  switchToDarkLabel,
}) => {
  const { isDarkMode, toggleTheme, isThemeReady } = useThemeToggle();
  const label = isDarkMode ? switchToLightLabel : switchToDarkLabel;

  return (
    <Button
      id={id}
      type="button"
      variant="ghost"
      size="icon"
      className={className}
      disabled={!isThemeReady}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      aria-busy={!isThemeReady}
    >
      {isDarkMode ? (
        <Sun className="size-5" aria-hidden />
      ) : (
        <Moon className="size-5" aria-hidden />
      )}
    </Button>
  );
};

export default ThemeToggleButton;
